// Environment configuration
// Development: Uses Vite's import.meta.env (from .env files)
// Production: Uses window.env (injected at runtime via config.js)

interface EnvConfig {
  BACKEND_URL: string;
  SENTRY_DSN?: string;
  SENTRY_ENV?: string;
  FRONTEND_VERSION?: string;
}

// Extend Window interface to include env
declare global {
  interface Window {
    env?: EnvConfig;
  }
}

const getConfig = (): EnvConfig => {
  // In development mode, prioritize Vite environment variables from .env files
  // This ensures correct values during local development
  const isDevelopment = import.meta.DEV;

  if (isDevelopment) {
    // Development: Use Vite env vars (from .env files)
    return {
      BACKEND_URL: import.meta.env.VITE_API_URL || "http://localhost:8000",
      SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
      SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV || "development",
      FRONTEND_VERSION: import.meta.env.VITE_FRONTEND_VERSION || "1.1.0",
    };
  }

  // Production: Use window.env (injected at runtime via config.js)
  // Fallback to import.meta.env if window.env is not available
  if (typeof window !== "undefined" && window.env) {
    return window.env;
  }

  // Fallback (shouldn't happen in production, but safe fallback)
  return {
    BACKEND_URL: import.meta.env.VITE_API_URL || "http://localhost:8000",
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV || "production",
    FRONTEND_VERSION: import.meta.env.VITE_FRONTEND_VERSION || "0.2.0",
  };
};

export const config = getConfig();
